module.exports = __webpack_public_path__ + "img/login-information-sheetB.0e151cce.png";